import BaseService from './base.service'

class PessoasService extends BaseService {
  constructor() {
    super({ resource: 'pessoa' })
  }
}

const pessoasService = new PessoasService()

export default pessoasService
